import {
  Bot,
  Cloud,
  Database,
  Headset,
  LayoutGrid,
  PhoneCall,
  Server,
  Shield,
  Wifi,
} from 'lucide-react';
import { NavItem } from './NavDropdown';

export const servicesDropdown: NavItem[] = [
  { to: '/services/managed-services', label: 'Managed Services', icon: Server },
  { to: '/services/connectivity', label: 'Connectivity', icon: Wifi },
  { to: '/services/voice', label: 'Voice Solutions', icon: PhoneCall },
  { to: '/services/security', label: 'Security', icon: Shield },
  { to: '/services/cloud', label: 'Cloud Services', icon: Cloud },
  { to: '/services/backup', label: 'Backup & Recovery', icon: Database },
  { to: '/services', label: 'All Services', divider: true, icon: LayoutGrid },
];

export const productsDropdown: NavItem[] = [
  { to: '/products/voicepro', label: 'VoicePro', icon: Headset },
  { to: '/products/msp-ai', label: 'MSP-AI', icon: Bot },
  { to: '/products', label: 'All Products', divider: true, icon: LayoutGrid },
];

export interface SimpleNavLink {
  to: string;
  label: string;
  /** Use startsWith matching instead of exact match */
  matchPrefix?: boolean;
}

export const simpleNavLinks: SimpleNavLink[] = [
  { to: '/industries', label: 'Industries', matchPrefix: true },
  { to: '/shop', label: 'Shop', matchPrefix: true },
  { to: '/specials', label: 'Specials' },
  { to: '/about', label: 'About' },
];
